"use strict";

module.exports = function isTwelveHourTime(groups) {
  return (/[a-z]/i.test(groups[groups.length - 1])
  );
};


//////////////////
// WEBPACK FOOTER
// ./~/time-input/dist/lib/is-twelve-hour-time.js
// module id = 1717
// module chunks = 0